import React from 'react';
import { Backdrop, CircularProgress } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

interface PageLoaderProps {
  loadingText?: string;
}

export const PageLoader = ({ loadingText }: PageLoaderProps) => {
  const renderLoadingText = (
    <span>
      {loadingText && <Typography variant="overline">{loadingText}</Typography>}
    </span>
  );

  return (
    <Backdrop style={{ zIndex: 9999 }} open>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fafafa',
        }}
      >
        <CircularProgress color="inherit" style={{ marginBottom: '8px' }} />
        {renderLoadingText}
      </div>
    </Backdrop>
  );
};
